import { render, staticRenderFns } from "./Forrajes.vue?vue&type=template&id=0b204834&scoped=true&"
import script from "./Forrajes.vue?vue&type=script&lang=js&"
export * from "./Forrajes.vue?vue&type=script&lang=js&"
import style0 from "./Forrajes.vue?vue&type=style&index=0&id=0b204834&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b204834",
  null
  
)

export default component.exports